module.exports = __webpack_public_path__ + "img/preview-4.08c54c04.png";